import { systemIds } from '@/shared/utils';
//  MCH_TECH_ACHIEVE("mch1050", "科技成果"),
//     MCH_INNOVATE_DEMAND("mch1060", "创新需求"),
//     MCH_DEMAND("mch1070", "需求管理"),
//     MCH_SUPPLY("mch1080", "供应管理（服务管理）"),
//     MCH_MERCHANT("mch2010", "商家管理"),
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['iip-company'], // 为了获取基础路由
    };
};
export const IIPCompanyToPathNameMap = {
    mch1050: ({ businessKey }) => {
        return commonFunc(`/iip-company/tech/achieve/detail?id=${businessKey}`);
    },
    mch1060: ({ businessKey }) => {
        return commonFunc(`/iip-company/innovate/demand/detail?id=${businessKey}`);
    },
    mch1070: ({ businessKey }) => {
        return commonFunc(`/iip-company/demand/detail?id=${businessKey}`);
    },
    mch1080: ({ businessKey }) => {
        return commonFunc(`/iip-company/supply/detail?id=${businessKey}`);
    },
    mch2010: ({ businessKey }) => {
        return commonFunc(`/iip-company/my-mch`);
    },
};
